export default {
    common: {
        goBack: 'Go back',
        home: 'Home',
        remove: 'Remove',
        test: 'test',
    },
    dropzone: {
        addMore: 'Add more files',
        canOnlyUploadImages: 'The file you are trying to upload is not allowed. You can only upload image files here.',
        canOnlyUploadPDF: 'The file you are trying to upload is not allowed. You can only upload PDF files here.',
        dragAndDropUploader: 'Drag and Drop Uploader',
        dragFiles: 'Drag your files here...',
        dropFiles: 'Drop files',
        fileTooBig: 'The file size is to big',
        invalidFileType: 'Invalid file type',
        maxFilesExceeded: 'You can not upload any more files',
        removeFile: 'Remove files',
        serverNotConfigured: 'Server not Configured',
        toUpload: 'to upload',
        uploadError: 'Upload failed',
    },
    errorCodes: {
        TOO_MANY_ATTACHMENTS:
            'You have uploaded too many attachments. Please do not exceed the limit of {0} attachments',
    },
    errorPages: {
        generalBody:
            'It seems that there is a problem with our system. We have immediately reported this problem to the webmaster so that we can resolve it as quickly as possible.',
        generalNeedHelp: 'Need help? Call',
        generalOpeningHours: 'Monday - Friday from 8:30 - 17:00 hours',
        generalSendEmail: 'Or send an email to info@ksyos.nl',
        generalTitle: 'Something went wrong',
        rumSessionId: 'Session ID',
    },
    errorResponses: {
        authorization: "You don't have access to this page or file (anymore).",
        controller: 'An error happened. (Technical status: {0})',
        internal: 'An internal server error happened.',
        joiValidation: 'There is a fault in the request. (Technical details: type "{0}", path "{1}")',
        noSession: 'Your session ended or you were not logged in. Please go to <a href="/home?view=login">login</a>.',
        notAllowed: "You don't have access to this page or file (anymore).",
        notFound: 'This page (or this file) does not exist.',
        samlError:
            'An error has occurred in the communication with DigiD. Please try again later. If this error persists, please visit the website https://www.digid.nl for the latest information or navigate to <a href="/login">login</a>.',
        unexpected: 'An unexpected error happened.',
        validation: 'There is a fault in the request. (Technical code: {0})',
        zxyTokenMissing: 'Missing security token.',
        zxyTokenNoMatch: 'The security token is incorrect.',
    },
    timeout: {
        message: 'To protect your data, you are logged out after 15 minutes of inactivity.',
        title: 'Your session has expired',
    },

    validation: {
        any_allowOnly: 'Value is not valid',
        any_empty: 'Can not be empty',
        any_emptySupport: 'Cannot be empty',
        any_invalid: 'The value is invalid',
        any_required: 'Can not be empty',
        any_selected: 'Choose one of the options',
        boolean_base: 'Cannot be empty',
        date_future: 'Date cannot be in the future',
        differentBsn: 'This is not the BSN of the patient',
        EXTERNALID_EXISTS: 'Serial number already exists for this devicetype',
        fev1: 'needs to be a number between 0 and 9 with two decimals',
        general: 'Something went wrong, please try again',
        graderRequired: 'Grader is required',
        greater: '"{0}" must be greater than "{1}"',
        IDENTIFIER_DECLARATION_EXISTS: 'This number is already in use',
        IDENTIFIER_REGISTRATION_EXISTS: 'This number is already in use',
        identifierDeclarationOrReferenceRequired:
            "For this profession the use of a AGB code or the use of an colleague's AGB code is required",
        image_required: 'Choose one of the images',
        invalidPhoneNumber: "The phone number doesn't seem to be correct. Check if there are at least 10 digits",
        koi_date: 'Input the date (dd-mm-yyyy).',
        koi_endDate: 'End date must be larger than or equal to Start date',
        koi_enum: 'Choose one of the options',
        koi_missingStartDate: 'StartDate is missing',
        koi_time: 'Input the time.',
        min: '"{0}" must be larger than or equal to "{1}"',
        NO_MATCH_DATE: 'Birthdate does not match the SSN registered in Client Safe',
        NO_MATCH_DATE_BSN: 'Combination SSN and birthdate does not exist',
        NO_VALID_INSURANCE: 'No valid insurance',
        noMatchDateBsn:
            'We could not find a patient matching this combination of birthdate and social security number. Please check your input.',
        noMatchDateBsnTextCreate:
            "The given birthdate and identifier social security don't match. Are you sure you want to create a patient with this data?",
        noMatchDateBsnTextUpdate:
            "The given birthdate and identifier social security don't match. Are you sure you want to overwrite the patientdata?",
        nonExistingBSN: 'SSN does not exist',
        noServiceGraderPoolProviders: 'No graders added',
        number_base: 'Must be a number',
        number_max: 'Number must be smaller',
        number_min: 'Number must be bigger',
        numberAsString_decimalComma: 'Must have a comma as decimal separator',
        numberAsString_decimalPoint: 'Must have a point as decimal separator',
        numberAsString_greater: 'Number must be bigger',
        numberAsString_leadingZero: 'No leading zeroes allowed',
        numberAsString_less: 'Number must be smaller',
        numberAsString_max: 'Number must be smaller',
        numberAsString_maxDecimals: 'Too many decimal places',
        numberAsString_min: 'Number must be bigger',
        numberAsString_minDecimals: 'Too few decimal places',
        numberAsString_negativeZero: 'Must be a number',
        numberAsString_noDecimals: 'Must not have decimals',
        numberAsString_notANumber: 'Must be a number',
        object_min: 'This question is required',
        onePhoneNumberRequired: 'Enter at least 1 phone number',
        OTP_SECRET_DOES_NOT_MATCH_TOTP_TOKEN: 'Incorrect Google Authenticator code',
        passwordNotGoodEnough: 'Must score 80% or more',
        permission_required: 'Provide permission to continue',
        REGISTRATION_CODE_EXPIRED: 'Your registration code has expired',
        REQUIRED: 'required',
        requiredForGp: 'Required',
        requiredForRole: 'Required',
        selectAtLeastOneSubCategory: 'You have to select at least one subcategory if you select a main category',
        string_base: 'Can not be empty',
        string_elfproef: 'Not a valid SSN',
        string_email: 'Invalid email address',
        string_empty: 'Can not be empty',
        string_ledgerNumber: 'Must consist of four digits',
        string_max: 'The text contains to many characters',
        string_min: 'The text contains to few characters',
        string_newPasswordRepeat: 'Must be equal to your chosen password',
        string_numeric: 'Must consist of digits',
        string_pattern: {
            base: 'Can not be empty',
        },
        string_regex: 'The provided value fails to match the required pattern',
        string_registrationCode: 'Must consist of twelve letters',
        string_totpToken: 'Must consist of six digits',
        timeParadox: ' must be after "{0}"',
        USERNAME_EXISTS: 'This username is already in use',
        USERNAME_NOT_FOUND: 'Unknown username',
        weeks_required: 'Enter number of weeks',
        WRONG_PASSWORD: 'Incorrect password',
        WRONG_REGISTRATION_CODE: 'Incorrect registration code',
        WRONG_TOTP_TOKEN: 'Incorrect Google Authenticator code',
    },
};
